var l = Object.defineProperty;
var r = (e, t, n) => t in e ? l(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n;
var i = (e, t, n) => r(e, typeof t != "symbol" ? t + "" : t, n);
import { io as a } from "socket.io-client";
class c {
  static init({ debug: t, url: n }) {
    this.debug = t, this.url = n;
  }
  static get(t) {
    if (this.instances.has(t))
      return this.instances.get(t);
    const n = a(`${this.url}${t}`, { autoConnect: !1 });
    return this.debug && (n.onAny(
      (o, ...s) => console.log(`INCOMING ${o}`, ...s)
    ), n.onAnyOutgoing(
      (o, ...s) => console.log(`OUTGOING ${o}`, ...s)
    ), n.on("disconnect", (o) => {
      console.info(`Disconnected: ${o}`);
    }), n.io.on("reconnect", () => {
      console.info("Reconnected");
    }), n.io.on("reconnect_attempt", (o) => {
      console.info(`Reconnection attempt #${o}`);
    }), n.io.on("reconnect_failed", () => {
      console.error("Reconnection failed");
    })), this.instances.set(t, n), n;
  }
}
i(c, "instances", /* @__PURE__ */ new Map()), i(c, "debug", !1), i(c, "url", "");
export {
  c as default
};
